import { IData } from '../interfaces/common';
import { getConfig } from '../utils/sessionStorageUtils';
import axios from './axios';
import { IBrand } from '../interfaces/product';

interface Brand {
  name: string;
  title: string;
  description: string;
  stringImage: string;
  id: string;

  seoTitle?: string;
  seoDescription?: string;
  seoKeywords?: string;

  urlSlug?: string;
}

export const addBrand = async (
  name: string,
  description: string,
  title: string,
  seoTitle: string,
  seoDescription: string,
  seoKeywords: string,
  urlSlug: string | null
) => {
  try {
    const result = await axios.post(
      `/Brands`,
      { name, description, title, seoTitle, seoDescription, seoKeywords, urlSlug },
      getConfig()
    );
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const deleteBrand = async (id: string) => {
  try {
    const result = await axios.delete(`/Brands/${id}`, getConfig());
    return result?.data;
  } catch (e) {
    throw e;
  }
};

export const getBrands = async () => {
  try {
    const result = await axios.get<IData<IBrand[]>>(`/Brands/GetAll`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getBrandsData = async (url: string) => {
  try {
    const result = await axios.get(`/Brands/${url || ''}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const getBrand = async (id: string): Promise<IData<IBrand> | undefined> => {
  try {
    const result = await axios.get(`/Brands/${id}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
    return undefined;
  }
};

export const getBrandByName = async (name: string) => {
  try {
    const result = await axios.get(`/Brands/${name}`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const putBrands = async (data: Brand) => {
  try {
    const result = await axios.put(`/Brands/${data.id}`, data, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};

export const brandExist = async (brandName: string) => {
  try {
    const result = await axios.get(`/Brands/${brandName}/exist`, getConfig());
    return result.data;
  } catch (e) {
    console.error(e);
  }
};
